<template>
  <div class="clinic-service-card">
    <b-row>
      <b-col cols="12" lg="4" xl="2" class="clinic-logo">
        <div class="d-block">
          <div  class="clinic-logo-box">
            <b-img-lazy
              v-if="!!service.clinic.logo_url"
              v-bind:onerror="`this.src='${cx_defaultLogo}';`"
              :src="service.clinic.logo_url"
              :alt="service.clinic.name"
              :title="service.clinic.name"
              class="default-logo">
            </b-img-lazy>
            <b-img-lazy
              v-else
              :src="cx_defaultLogo"
              :alt="service.clinic.name"
              :title="service.clinic.name"
              class="default-logo">
            </b-img-lazy>
          </div>
          <div class="rating-info">
            <div class="form-rating">
              <b-form-rating class="rating" v-model="cx_clinic_rating" color="#FDCB2E" readonly no-border></b-form-rating>
              <div class="clinic-total-rating">{{ cx_rating_count === 1 ? '1 avaliação' : `${cx_rating_count} avaliações` }}</div>
            </div>
          </div>
        </div>
      </b-col>

      <b-col cols="12" lg="5" xl="8">
        <div class="clinic-info">
          <label class="clinic-name" v-bind:class="{ colorTenancy: $route.name == 'SearchServicesTenancy' }">
            {{ service.clinic.name }}
          </label>
          <div class="clinic-address">
            <img height="15" width="15" src="@/assets/icons/location_searching.svg" />
            <span>{{ formattedAddress(service.clinic.address) }}</span>
          </div>
          <div class="clinic-distance">
            <img height="20" width="15" src="@/assets/icons/directions_run.svg" />
            <span> Distância: {{ formattedDistance(service.distance) }} </span>
          </div>

          <label v-if="clinicAvailableHours[service.clinic.id]" class="available-hours-label">Horários disponíveis {{ getAppointmentDate }}</label>
          <vue-scroll class="hour-picker-container" ref="vs" :ops="cx_vueScrollOption">
            <div v-if="clinicAvailableHours[service.clinic.id]" class="d-flex hours-box">
              <div 
                class="available-hour" 
                v-for="(hour, clinicId) in clinicAvailableHours[service.clinic.id]" 
                :key="clinicId"
                @click="selectTime(hour, $event, service.clinic.id)"
              >
                {{ hour && hour.start }}
              </div>
            </div>
            <div v-else class="no-available-hours mt-4 mb-4">Não possui horários disponíveis nesta data</div>
          </vue-scroll>
          <div class="vue-slick-carousel-component" v-if="clinicAvailableHours[service.clinic.id]">
            <label class="available-hours-label">Horários disponíveis {{ getAppointmentDate }}</label>
            <VueSlickCarousel class="carousel-component" :arrows="true" v-bind="settings">
              <div 
                class="clinic-hour"
                :class="{ 'disabled-clinic-hour': hour && !hour.available }"
                v-for="(hour, index) in clinicAvailableHours[service.clinic.id]"
                :key="index"
                @click="selectTime(hour, $event, service.clinic.id)"
              >
                {{hour && hour.start}}
              </div>

              <template #prevArrow>
                <b-icon class="carousel-arrow" icon="chevron-left"></b-icon>
              </template>

              <template #nextArrow>
                <b-icon class="carousel-arrow" icon="chevron-right"></b-icon>
              </template>
            </VueSlickCarousel>
              
            <div class="hours-skeleton" v-if="!clinicAvailableHours[service.clinic.id]">
              <b-icon class="carousel-arrow skeleton-prev-arrow" icon="chevron-left"></b-icon>
              <div class="loading-animation clinic-hour" v-for="(placeholder, index) in 6" :key="index"></div>
              <b-icon class="carousel-arrow skeleton-next-arrow" icon="chevron-right"></b-icon>
            </div>
          </div>
          <div v-else class="no-available-hours">Não possui horários disponíveis nesta data</div>
        </div>
      </b-col>
      <b-col cols="12" lg="3" xl="2" v-if="service.service_default_name.code != '1076' ">
        <label class="service-name">{{ service.service_default_name.search_name }}</label>
        <b-row class="d-flex d-lg-block">
          <b-col  cols="6" lg="12">
            <label class="service-price">{{ formattedCurrency(service.price) }}</label>
            <p class="payment-info-label">Pague direto no local</p>
          </b-col>
          <b-col cols="6" lg=12 class="schedule-button">
            <button
              v-on:click="$emit('goToSchedule', service, clinicAvailableHours[service.clinic.id])"
            >
              Agendar
            </button>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" lg="3" xl="2" v-else>
        <label class="service-name-psa">{{ service.service_default_name.search_name }}</label>
        <b-row class="d-flex d-lg-block">
          <b-col cols="6" lg="12">
            <label class="service-price-before">De {{ formattedCurrency(service.price) }} <span class="card-coupom">-100%</span></label>
            <label class="service-price-after">Por {{ formattedCurrency(0.00) }}</label>
            <p class="payment-info-label">Válido para Campanha Feliz Idade</p>
          </b-col>
          <b-col cols="6" lg=12 class="schedule-button">
            <button
              v-on:click="$emit('goToSchedule', service, clinicAvailableHours[service.clinic.id])"
            >
              Agendar
            </button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ServiceClinicCard from "@/components/ClinicsResult/ServiceClinicCard/ServiceClinicCard";
export default ServiceClinicCard;
</script>

<style lang="scss" scoped>
@import "ServiceClinicCard.scss";
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@600;700&display=swap");
</style>
